<template>

  <!-- Quiz Answers Selector -->
  <div
    class="quiz-answers-selector">

    <q-card
      :key="item.id"
      v-for="item in items"
      :class="getAnswerStatus(item)"
      @click.capture.stop="select(item)"
      class="text-left q-pa-sm generic-radius">

      <div
        class="flex row no-wrap items-center">

        <div
          class="q-pr-sm">

          <q-checkbox
            @click="select(item)"
            :value="getCheckboxStatus(item)"/>

        </div>

        <div
          class="col">
          {{ item.title.ru }}
        </div>

      </div>

    </q-card>

  </div>

</template>

<script>

  import InputMixin from '@src/mixins/input-mixin';

  export default {
    name: 'quiz-answers-selector',
    mixins: [
      InputMixin,
    ],
    props: {
      value: {
        type: Object,
        default: null,
      },
      items: {
        type: Array,
        default: () => [],
      },
      invalid: {
        type: Object,
        default: null,
      },
      correct: {
        type: Object,
        default: null,
      },
    },
    computed: {
      selectedId() {

        return this.value
          && this.value.id
          || '';
      },
      invalidId() {

        return this.invalid
          && this.invalid.id
          || '';
      },
      correctId() {

        return this.correct
          && this.correct.id
          || '';
      },
    },
    methods: {
      select(item) {

        if (this.correct)
          return;

        if (!item)
          this.input(null);

        this.input(
          this.value === item
            ? null
            : item,
        );
      },
      getAnswerStatus(item) {

        if (
          this.correctId &&
          item.id === this.correctId
        ) return 'correct';

        if (
          this.correctId &&
          item.id === this.invalidId
        ) return 'invalid';

        if (item.id === this.selectedId)
          return 'selected';

        return '';
      },
      getCheckboxStatus(item) {

        const status = this.getAnswerStatus(item);

        if (status === 'invalid')
          return null;

        return this.selectedId === item.id
          || this.correctId === item.id;
      },
    },
  };

</script>

<style lang="scss">

  .quiz-answers-selector {
    color: inherit;

    .q-card {
      color: $primary;
      cursor: pointer;
      font-weight: 600;
      font-size: 1.1rem;
      user-select: none;
      line-height: 1.6rem;
      transition: background .1s linear;

      @media (max-width: $breakpoint-xs) {
        font-size: 1rem;
        line-height: 1.5rem;
      }
    }

    .q-card.selected {
      color: white;
      background: $brand-gradient;

      .q-checkbox__bg {
        border-color: white;
      }
    }

    .q-card.invalid {
      color: white;
      background: $negative;

      .q-checkbox__bg {
        border-color: white;
      }
    }

    .q-card.correct {
      color: white;
      background: $green-14;

      .q-checkbox__bg {
        border-color: white;
      }
    }

    .q-card:not(:first-child) {
      margin-top: 1rem;
    }

    .q-checkbox {
      margin-bottom: 0 !important;
    }

    .q-checkbox__bg {
      border-color: #00B9FF;
      background-color: transparent;
    }

    .q-checkbox__inner {
      min-width: 0;
      min-height: 0;
      width: 2.4rem;
      height: 2.4rem;
      max-width: none;
      max-height: none;

      @media (max-width: $breakpoint-xs) {
        width: 2.1rem;
        height: 2.1rem;
      }
    }

    .q-checkbox__bg {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-width: 6px;

      @media (max-width: $breakpoint-xs) {
        border-width: 4.5px;
      }
    }

    .q-checkbox__svg {
      top: -4px;
      left: -1px;
      color: #1e1e1e;
      width: 103% !important;
      height: 119% !important;
    }

    .q-checkbox__inner:before {
      display: none !important;
    }
  }

</style>
